import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqAccordion({ limit }: { limit?: number }) {
  const [open, setOpen] = useState<number | null>(0);
  const list = limit ? faqs.slice(0, limit) : faqs;

  return (
    <div className="space-y-3">
      {list.map((f, i) => {
        const active = open === i;
        return (
          <div
            key={i}
            className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpen(active ? null : i)}
              aria-expanded={active}
              className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
            >
              <span className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-base">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                  Q
                </span>
                {f.q}
              </span>
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                  active ? 'rotate-180' : ''
                }`}
              >
                <i className="ri-arrow-down-s-line text-lg"></i>
              </span>
            </button>
            {active && (
              <div className="border-t border-background-100 px-5 py-4">
                <p className="flex gap-3 text-sm leading-relaxed text-foreground-600">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-800">
                    A
                  </span>
                  <span>{f.a}</span>
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}